<template>
  <v-stepper-content step="5" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">Company Payroll Information</div>
          </v-col>

          <v-col
            cols="12"
            class="mt-8"
          >
            <div class="text-md-body-1 text-body-2">How many employees (excluding owners) are on payroll?</div>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Full-Time"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="employeePayrollInfo.fullTime"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Part-Time"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="employeePayrollInfo.partTime"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              prepend-inner-icon="mdi-currency-usd"
              label="Annual Payroll"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="employeePayrollInfo.annualPayroll"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-combobox
              v-model="employeePayrollInfo.payrollFrequency"
              :items="payrollFrequency"
              outlined
              label="Payroll Frequency"
              class="rounded-lg"
            ></v-combobox>
          </v-col>

          <v-col
            cols="12"
            class="mt-8"
          >
            <div class="text-md-body-1 text-body-2">How many owners are on payroll?</div>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Full-Time"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="ownerPayrollInfo.fullTime"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Part-Time"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="ownerPayrollInfo.partTime"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              prepend-inner-icon="mdi-currency-usd"
              label="Annual Payroll"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="ownerPayrollInfo.annualPayroll"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-combobox
              v-model="ownerPayrollInfo.payrollFrequency"
              :items="payrollFrequency"
              outlined
              label="Payroll Frequency"
              class="rounded-lg"
            ></v-combobox>
          </v-col>

          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'StepFive',
  components: {
    BtnContinue,
  },
  data: () => ({
    payrollFrequency: [
      'Weekly',
      'Bi-Weekly',
      'Semi-Monthly',
      'Other',
    ],
    // selectedEmployeeFrequency: null,
    selectedOwnerFrequency: null,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    employeePayrollInfo: {
      get() {
        return this.$store.state.prospectPacket.payrollInformation.employees;
      },
      set(value) {
        this.$store.commit('updateEmployeePayrollInfo', value);
      },
    },
    ownerPayrollInfo: {
      get() {
        return this.$store.state.prospectPacket.payrollInformation.owners;
      },
      set(value) {
        this.$store.commit('updateOwnerPayrollInfo', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
